"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const CARDS = ["fullCycleCard1", "fullCycleCard2", "fullCycleCard3"] as const;

const IMAGE =
	"/image/new-version/ValueAddedSolutions/industrial-automation/full-cycle-rapid-manufacturing-partner-for-automation-projects.webp";

export default function IndustrialAutomationFullCycle() {
	const t = useTranslations("new-industrial-automation");

	return (
		<section className="bg-[#eeeeee] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("fullCycleTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("fullCycleDesc")}</p>
				</header>

				<div className="grid gap-6 lg:grid-cols-[0.95fr_1.05fr] lg:gap-10">
					<div className="grid gap-5">
						{CARDS.map((keyPrefix) => (
							<article key={keyPrefix} className="rounded-2xl bg-white p-6 shadow-sm sm:p-8 lg:p-20">
								<h3 className="mb-3 text-lg font-bold leading-tight text-themePrimary400 sm:text-xl">
									{t(`${keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${keyPrefix}Desc`)}</p>
							</article>
						))}
					</div>

					<div className="relative min-h-[360px] bg-white p-4 sm:min-h-[480px] sm:p-8 lg:min-h-full">
						<Image
							src={IMAGE}
							alt={t("fullCycleImageAlt")}
							fill
							className="object-contain p-6"
							sizes="(max-width: 1024px) 100vw, 50vw"
						/>
					</div>
				</div>

				<div className="mt-8 flex justify-center sm:mt-10">
					<Link
						href="/upload"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("fullCycleGetInstantQuote")}
					</Link>
				</div>
			</div>
		</section>
	);
}
